import type { TemplateId } from "@lifescapsule/contracts";
import type { CanonicalAssetId } from "../../shared/canonical-assets";

export const catalogFixtureByTemplate: Partial<
  Record<TemplateId, { asset: CanonicalAssetId; label: string }>
> = {
  story: {
    asset: "LC-ASSET-BOOKS-FIXTURES-NARRATIVE-MY-STORY",
    label: "My Story hardcover",
  },
  love: {
    asset: "LC-ASSET-BOOKS-FIXTURES-NARRATIVE-OUR-STORY",
    label: "Our Story hardcover",
  },
  children: {
    asset: "LC-ASSET-BOOKS-FIXTURES-PICTURE-LITTLE-MOMENTS",
    label: "Bedtime picture book",
  },
  recipes: {
    asset: "LC-ASSET-BOOKS-FIXTURES-RECIPE-FAMILY-RECIPES",
    label: "Family recipe book",
  },
};

export function hasCatalogFixture(templateId: TemplateId) {
  return Boolean(catalogFixtureByTemplate[templateId]);
}
